import React from 'react';

import { useParams } from 'react-router-dom';

import { Alert, Paper, Stack, Typography } from '@mui/material';

import { useGetOffer } from '~/hooks/apis/offers/useGetOffer';
import { useGetOfferRoomTypes } from '~/hooks/apis/reservation/useOfferRoomTypes';

import { getOfferPropertyId } from '../../utils';

import RoomTypesTable from './RoomTypesTable';

export default function RoomTypesTab() {
  const { id_offer: offerId } = useParams<{ id_offer: string }>();
  const { data: offer } = useGetOffer(offerId);
  const vendorId = offer?.vendor_account_id;
  const propertyId = getOfferPropertyId(offer);
  const { data: roomTypes = [], isLoading, error } = useGetOfferRoomTypes(propertyId, vendorId);

  return (
    <Paper variant="outlined" sx={{ p: 3 }}>
      <Stack direction="row" justifyContent="space-between" alignItems="flex-start" sx={{ mb: 3 }}>
        <Stack spacing={0.5}>
          <Typography variant="h6">Room types</Typography>
          <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 640 }}>
            Room types come from the property's room records. Open a room to manage its inventory, surcharges,
            blackouts, capacity and extra guest surcharges.
          </Typography>
        </Stack>
        <Typography variant="body2" color="text.secondary" sx={{ whiteSpace: 'nowrap' }}>
          <Typography component="span" variant="subtitle2">
            {roomTypes.length}
          </Typography>{' '}
          room {roomTypes.length === 1 ? 'type' : 'types'}
        </Typography>
      </Stack>

      {error ? (
        <Alert severity="error">Unable to load room types.</Alert>
      ) : (
        <RoomTypesTable loading={isLoading} roomTypes={roomTypes} />
      )}
    </Paper>
  );
}
